// extracted by mini-css-extract-plugin
export default {"installedGroup":"bb0da0bebab6","darkText":"d37879d303e8"};